import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { Input, InputProps } from '../../UI/components/Form';
import { NoteReceivableFormValues } from '../types';

type NoteReceivableNicknameInputProps = Pick<InputProps, 'className'> & InputProps['inputProps'];

export const NoteReceivableNicknameInput: FC<NoteReceivableNicknameInputProps> = ({ className, ...inputProps }) => {
  const { t: tForm } = useTranslation('form');
  const {
    register,
    formState: { errors },
  } = useFormContext<NoteReceivableFormValues>();

  return (
    <Input
      className={className}
      {...register('nickname', { required: true })}
      status={errors.nickname ? 'errored' : 'normal'}
      label={tForm('note-receivable-nickname-input-label')}
      inputProps={{ required: true, placeholder: tForm('general-placeholder-required'), ...inputProps }}
    />
  );
};
